import Quill from 'quill';
import Mention from './quill-mention/quill.mention';

Quill.register('modules/mention', Mention);

frappe.ui.form.ControlComment = frappe.ui.form.ControlTextEditor.extend({
	make_wrapper() {
		this.comment_wrapper = !this.no_wrapper ? $(`
				<div class="comment-input-wrapper">
					<div class="comment-input-header">
					<span class="small text-muted">${__("Add a comment")}</span>
					<button class="btn btn-default btn-comment btn-xs pull-right">
						${__("Comment")}
					</button>
				</div>
				<div class="comment-input-container">
					<div class="frappe-control"></div>
					<div class="text-muted small">
						${__("Ctrl+Enter to add comment")}
					</div>
				</div>
			</div>
		`) : $('<div class="frappe-control"></div>');

		this.comment_wrapper.appendTo(this.parent);

		// wrapper should point to frappe-control
		this.$wrapper = !this.no_wrapper
			? this.comment_wrapper.find('.frappe-control')
			: this.comment_wrapper;

		this.wrapper = this.$wrapper;

		this.button = this.comment_wrapper.find('.btn-comment');
	},

	bind_events() {
		this._super();

		this.button.click(() => {
			this.submit();
		});

		this.$wrapper.on('keydown', e => {
			const key = frappe.ui.keys.get_key(e);
			if (key === 'ctrl+enter') {
				e.preventDefault();
				this.submit();
			}
		});

		this.quill.on('text-change', frappe.utils.debounce(() => {
			this.update_state();
		}, 300));
	},

	submit() {
		const value = this.get_value();
		this.on_submit && this.on_submit(value);
	},

	get_value() {
		// Get the value from the parent class
		let value = this._super();
		
		// Check if we have any mention blots and ensure they're properly formatted
		if (this.quill) {
			const contents = this.quill.getContents();
			
			// Check for any mention operations in the delta
			let hasMentions = false;
			contents.ops.forEach(op => {
				if (op.insert && typeof op.insert === 'object' && op.insert.mention) {
					hasMentions = true;
				}
			});
			
			if (hasMentions) {
				// Force regenerate HTML to ensure mentions are properly rendered
				const tempDiv = document.createElement('div');
				const clonedQuill = this.quill.root.cloneNode(true);
				tempDiv.appendChild(clonedQuill);
				value = tempDiv.innerHTML;
			}
		}
		
		return value;
	},

	update_state() {
		const value = this.get_value();
		if (strip_html(value)) {
			this.button.removeClass('btn-default').addClass('btn-primary');
		} else {
			this.button.addClass('btn-default').removeClass('btn-primary');
		}
	},

	get_quill_options() {
		const options = this._super();
		return Object.assign(options, {
			theme: 'bubble',
			modules: Object.assign(options.modules, {
				mention: this.get_mention_options()
			})
		});
	},

	get_mention_options() {
		// Always ensure we have some basic mentions available
		let base_mentions = this.mentions || [];
		
		// Add Administrator if not already present
		const admin_exists = base_mentions.some(mention => {
			if (typeof mention === 'string') {
				return mention === 'Administrator';
			} else if (typeof mention === 'object' && mention !== null) {
				return mention.id === 'Administrator' || mention.value === 'Administrator';
			}
			return false;
		});
		
		if (!admin_exists) {
			base_mentions.push('Administrator');
		}
		
		// Add current user if not already present
		if (frappe.session.user && frappe.session.user !== 'Administrator') {
			const user_exists = base_mentions.some(mention => {
				if (typeof mention === 'string') {
					return mention === frappe.session.user;
				} else if (typeof mention === 'object' && mention !== null) {
					return mention.id === frappe.session.user || mention.value === frappe.session.user;
				}
				return false;
			});
			
			if (!user_exists) {
				base_mentions.push(frappe.session.user);
			}
		}
		
		if (!(base_mentions && base_mentions.length)) {
			return null;
		}

		// Convert mentions to proper format if they're not already objects
		const at_values = base_mentions
			.filter(mention => mention != null) // Filter out null/undefined values
			.map((mention, i) => {
				if (typeof mention === 'string') {
					// Legacy format - convert to object
					const user_info = frappe.user_info(mention);
					return {
						id: mention,
						value: user_info.fullname || mention
					};
				} else if (typeof mention === 'object' && mention !== null) {
					// Already an object with id and value
					return {
						id: mention.id || mention.email || mention.value,
						value: mention.value || mention.id
					};
				} else {
					// Invalid mention format, skip it
					return null;
				}
			})
			.filter(mention => mention !== null); // Remove any null results
		
		return {
			allowedChars: /^[A-Za-z0-9_]*$/,
			mentionDenotationChars: ["@"],
			isolateCharacter: true,
			source: (searchTerm, renderList, mentionChar) => {
				let values;

				if (mentionChar === "@") {
					values = at_values;
				}

				if (searchTerm.length === 0) {
					renderList(values.slice(0, 15), searchTerm); // Limit initial list
				} else if (searchTerm.length < 2) {
					// Show cached users for short searches
					const matches = [];
					for (let i = 0; i < values.length && matches.length < 10; i++) {
						if (~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())) {
							matches.push(values[i]);
						}
					}
					renderList(matches, searchTerm);
				} else {
					// For longer searches, just use static search to avoid permission issues
					const matches = [];
					for (let i = 0; i < values.length; i++) {
						if (~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())) {
							matches.push(values[i]);
						}
					}
					renderList(matches, searchTerm);
				}
			},
		};
	},

	get_toolbar_options() {
		return [
			['bold', 'italic', 'underline'],
			['blockquote', 'code-block'],
			['link', 'image'],
			[{ 'list': 'ordered' }, { 'list': 'bullet' }],
			['clean']
		];
	},

	clear() {
		this.quill.setText('');
	},

	// Refresh mentions when user info is updated
	refresh_mentions() {
		if (this.quill && this.quill.getModule('mention')) {
			// Update the mentions array with fresh user info
			const updated_mentions = this.mentions.map(mention => {
				if (typeof mention === 'string') {
					const user_info = frappe.user_info(mention);
					return {
						id: mention,
						value: user_info.fullname || mention
					};
				} else {
					const user_info = frappe.user_info(mention.id || mention.email);
					return {
						id: mention.id || mention.email || mention.value,
						value: user_info.fullname || mention.value || mention.id
					};
				}
			});
			
			this.mentions = updated_mentions;
		}
	}
});
